import React from "react";

import { RouteComponentProps, withRouter } from "react-router-dom";

import { DirectionPageState } from "./models";

import {
    Box,
    Button,
    Grid,
    Stack,
    Typography,
} from "@mui/material";

import Chip from '@mui/material/Chip';

import { Content } from "models";

import ZPlayLoader from "commons/zplay-loader";
import NavigationBack from "commons/navigation/navigation-back/navigation-back";

import { ContentEnduserService } from "services/content-enduser-service";

import { Trans } from "@lingui/macro";
import EditLiveInfoModal from "components/backoffice/direction-table/edit-live-info-modal";
import { BringLiveConfirmationModal } from "components/backoffice/direction-table/bring-live-confirmation-modal";
import { Player } from "components/player-page/player/player";


class DirectionPage extends React.Component<RouteComponentProps<any>, DirectionPageState> {

    constructor(props: any) {

        super(props);

        this.state = {
            isLoading: true,
            showEditLiveInfoModal: false,
            user: null,
            showRegistrationDialog: false,
            showConfirmationModal: false,
            content: null,
        };
    }

    componentDidMount() {

        ContentEnduserService.getContentById(this.props.match.params.contentId, this.getContentSuccessCallback, this.errorCallback)
    }

    getContentSuccessCallback = (data: Content) => {
        this.setState(() => ({ isLoading: false, content: data }))
    }

    errorCallback = (err: any) => {
        console.log(err)
    }

    updateLiveInfo = (liveInfo: any, successCallback: any, errCallback: any) => {
        this.setState(() => ({ isLoading: true }))
    }

    showEditLiveInfoModal = () => {
        this.setState(() => ({
            showEditLiveInfoModal: true,
        }))
    }

    updateTable = () => {
        ContentEnduserService.getContentById(this.props.match.params.contentId, this.getContentSuccessCallback, this.errorCallback)
    }

    closeEditLiveInfoModal = () => {

        this.updateTable();

        this.setState(() => ({
            showEditLiveInfoModal: false,
        }));

        this.setState(() => ({ isLoading: false }))
    }

    closeConfirmationModal = () => {
        this.setState(() => ({
            showConfirmationModal: false,
        }))
    }

    showConfirmationModal = () => {
        this.setState(() => ({
            showConfirmationModal: true,
        }))
    }

    setContentLiveSuccessCallback = () => {
        window.location.reload();
    }

    goLive = () => {

    }

    render() {
        return (<>
            {this.state.isLoading && <ZPlayLoader />}
            {!this.state.isLoading && this.state.content !== null && <>
                <BringLiveConfirmationModal showConfirmationModal={this.state.showConfirmationModal}
                    closeConfirmationModal={this.closeConfirmationModal}
                    goLive={this.goLive}></BringLiveConfirmationModal>
                <EditLiveInfoModal showEditLiveInfoModal={this.state.showEditLiveInfoModal}
                    closeEditLiveInfoModal={this.closeEditLiveInfoModal}
                    editLiveInfo={this.updateLiveInfo} liveInfo={this.state.content} />
                <Grid container>
                    <Grid item xs={12} sx={{ mb: 1 }}>
                        <NavigationBack backRoute={"/backoffice/manage-content"} />
                    </Grid>
                    <Grid item xs={7}>
                        <Player content={this.state.content} />
                    </Grid>
                    <Grid item xs={5} sx={{ p: 1, w: 100 }}>
                        <Stack spacing={2}>
                            <Box>
                                <Stack spacing={1} direction={"row"}>
                                    <Typography sx={{
                                        color: process.env.REACT_APP_DEFAULT_TEXT_COLOR
                                    }}>
                                        <Trans id="dtl-rtmp1"> RTMP A (Main)</Trans>
                                    </Typography>
                                    <Chip
                                        color={"primary"}
                                        label={(this.state.content.liveAdditionalInfos && this.state.content.liveAdditionalInfos.streamingInputRTMPUrls && this.state.content.liveAdditionalInfos.streamingInputRTMPUrls[0]) ? this.state.content.liveAdditionalInfos?.streamingInputRTMPUrls[0] : "/"} />
                                </Stack>
                            </Box>
                            <Box>
                                <Stack spacing={1} direction={"row"}>
                                    <Typography sx={{
                                        color: process.env.REACT_APP_DEFAULT_TEXT_COLOR
                                    }}>
                                        <Trans id="dtl-rtmp2"> RTMP B</Trans>
                                    </Typography>
                                    <Chip
                                        color={"secondary"}
                                        label={(this.state.content.liveAdditionalInfos && this.state.content.liveAdditionalInfos.streamingInputRTMPUrls && this.state.content.liveAdditionalInfos.streamingInputRTMPUrls[1]) ? this.state.content.liveAdditionalInfos?.streamingInputRTMPUrls[1] : "/"} />
                                </Stack>
                            </Box>
                        </Stack>
                    </Grid>
                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <Stack spacing={2} direction={"row"}>
                            <Button
                                variant="contained"
                                color={"primary"}
                                onClick={() => {
                                    this.showEditLiveInfoModal()
                                }}>
                                <Trans id="df-modify-button">Modifica Informazioni</Trans>
                            </Button>
                            <Button
                                variant="contained"
                                color={"secondary"}>
                                <Trans id="df-go-live-button">Accensione macchine diretta</Trans>
                            </Button>
                        </Stack>
                    </Grid>
                </Grid>
            </>}
        </>);
    }
}

export default withRouter(DirectionPage);
